import { Button, Link, Stack, Typography } from '@montugroup/design-system';
import { styled, SvgIcon } from '@mui/material';

export const ConsultationContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(6),
  borderRadius: theme.spacing(2),
  border: '1px solid rgba(0, 0, 0, 0.20)',
  backgroundColor: theme.palette.common.white,
  width: theme.spacing(111),
  gap: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const DetailText = styled(Typography)(({ theme }) => ({
  lineHeight: theme.spacing(6),
}));

export const ManageButton = styled('button')(({ theme }) => ({
  color: theme.palette.info.main,
  fontFamily: theme.typography.body1.fontFamily,
  textDecoration: 'underline ',
  textAlign: 'left',
  cursor: 'pointer',
  border: 'none',
  background: 'none',
  '&:hover': {
    color: theme.palette.info.main,
  },
  '& span': {
    paddingLeft: theme.spacing(1),
  },
  '&:focus': {
    outline: 'none',
  },
  '&:focus-visible': {
    outline: 'auto',
  },
}));

export const StartButtonLink = styled(Link)(() => ({
  textDecoration: 'none',
  width: '100%',
}));

export const StartButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: theme.spacing(13),
}));

export const AccessMessage = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  padding: theme.spacing(2, 0),
  alignSelf: 'flex-start',
}));

export const BoldText = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: 0,
}));

// read by screen readers but not shown; the design system's visuallyHidden isn't exported, so this matches it
export const VisuallyHidden = styled('span')({
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
  border: 0,
});

export const StyledIcon = styled(SvgIcon)(({ theme }) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  color: theme.palette.info.main,
  marginRight: theme.spacing(1),
}));
